<template>
  <div class="dynamic-list">
    <div class="dynamic-nav">
      <div class="dynamic-title">行业动态列表</div>
      <div class="dynamic-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="最新" name="1"></el-tab-pane>
          <el-tab-pane label="最热" name="2"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="search">
        <el-input v-model="keyword" size="small" style="width: 480px" suffix-icon="el-icon-search" placeholder="行业动态文章标题" @change="search"></el-input>
      </div>
    </div>
    <div class="dynamic-content scrollbar">
      <div class="sort">
        <span v-if="activeName == 1">时间</span>
        <span v-if="activeName == 2">热度</span>
        <svg v-if="asc" class="icon sort-img" aria-hidden="true" @click="setAsc(false)">
          <use xlink:href="#icon-daoxu"></use>
        </svg>
        <svg v-if="!asc" class="icon sort-img" aria-hidden="true" @click="setAsc(true)">
          <use xlink:href="#icon-shengxu"></use>
        </svg>
      </div>
      <ul v-loading="loading" class="list" @scroll="scrollEvent">
        <li v-for="(item, i) in dataList" :key="i" class="item">
          <img class="item-logo" :src="getUrl(item.titleImage)" alt="" @click="toDetiled(item.id)" />
          <div class="content">
            <div class="title vertical2" @click="toDetiled(item.id)">
              {{ item.title }}
            </div>
            <div class="text vertical2">{{ item.summary }}</div>
            <div class="time">
              <span> <i class="iconfont icon-shijian"></i>{{ item.publishTime }} </span>
              <span><i class="iconfont icon-liulanliang"></i>{{ item.viewCount }}</span>
            </div>
          </div>
        </li>
        <el-empty v-if="!dataList && !dataList.length && !loading" :image="isHotspotEmpty ? enptyIndustry : emptyData" :image-size="240" :description="isHotspotEmpty ? '当前暂无行业动态' : '未检索到相关行业动态'"> </el-empty>
      </ul>
    </div>
  </div>
</template>

<script>
import { listArticles } from '@/api/dynamic'
export default {
  async asyncData({ $axios }) {
    alert()
    const url = `/services/articles/listArticles`
    try {
      const res = await $axios.post(url, {
        keyword: '',
        asc: false,
        sortByHot: false,
        currentPage: 1,
        pageSize: 10
      })
      return {
        dataList: res.data.data.list
      }
    } catch (error) {
      console.error(error)
      return {
        dataList: []
      }
    }
  },
  data() {
    return {
      loading: false,
      keyword: '',
      dataList: [],
      activeName: '1',
      pageSize: 10,
      currentPage: 1,
      total: 0,
      asc: false, //  true /false
      sortByHot: false, //  true 最新 / false 最热
      isHotspotEmpty: false,
      emptyData: require('../../assets/images/enpty/empty-data.png'),
      enptyIndustry: require('../../assets/images/enpty/enpty-industry.png')
    }
  },
  mounted() {
    this.isHotspotEmpty = sessionStorage.getItem('isHotspotEmpty') || false
    this.getData()
  },
  methods: {
    getUrl(url) {
      if (url?.substring(0, 4) === 'http') {
        return url
      } else {
        return 'https://' + url
      }
    },

    //  搜索
    search() {
      this.currentPage = 1
      this.dataList = []
      this.getData()
    },

    // 滚动条触发事件
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.clientHeight === e.srcElement.scrollHeight) {
        if (this.total === this.dataList?.length) {
          return
        }
        this.currentPage += 1
        this.getData()
      }
    },

    // 排序
    setAsc(bool) {
      this.asc = bool
      this.currentPage = 1
      this.dataList = []
      this.getData()
    },

    // 获取行业动态
    async getData() {
      const params = {
        keyword: this.keyword,
        asc: this.asc,
        sortByHot: this.sortByHot,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.loading = true
      const res = await listArticles(params)
      this.loading = false
      const { data, success, msg } = res
      if (!success) return this.$message.error(msg)
      this.total = data.total
      this.dataList = this.dataList.concat(data.list)
    },

    //  切换
    handleClick(tab) {
      this.currentPage = 1
      this.sortByHot = tab.name === 2
      this.dataList = []
      this.getData()
    },

    //  详情
    toDetiled(id) {
      const par = {
        keyword: this.keyword,
        asc: this.asc,
        sortByHot: this.sortByHot,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.$router.push({
        name: 'dynamicDetail',
        params: { id, type: 'list', par }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dynamic-list {
  height: calc(100vh - 100px);
  .dynamic-nav {
    margin-left: 48px;
    padding: 24px 48px 0 0;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
    .dynamic-title {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
      letter-spacing: 1px;
    }
    .dynamic-tabs {
      margin-top: 28px;
      height: 44px;
    }

    .search {
      position: absolute;
      bottom: 16px;
      right: 0;
    }
  }
  .dynamic-content {
    // min-height: calc(100% - 134px);
    border-right: 1px solid #f0f0f0;
    .sort {
      width: 100%;
      padding: 16px 28px 0 0;
      text-align: right;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 1px;
      display: flex;
      span {
        padding-right: 16px;
        margin-left: auto;
      }
      i {
        cursor: pointer;
      }
      .sort-img {
        width: 12px;
        height: 12px;
        margin-top: 4px;
        cursor: pointer;
      }
    }
    .list {
      margin-top: 16px;
      padding: 0 48px;
      overflow: auto;
      height: 1084px;

      .el-empty {
        margin-top: 289px;
        .el-empty__description {
          margin-top: 8px;
          p {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #666666;
            line-height: 20px;
          }
        }
      }
      .item {
        width: 100%;
        height: 160px;
        margin-bottom: 24px;
        display: flex;
        position: relative;

        .item-logo {
          width: 200px;
          height: 160px;
          cursor: pointer;
          background-color: #eee;
        }

        .content {
          flex: 1;
          padding-left: 16px;
          div {
            max-height: 50px;
          }
          .title {
            font-size: 18px;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            letter-spacing: 1px;
            margin-bottom: 16px;
            cursor: pointer;
          }
          .text {
            font-size: 18px;
            font-weight: 400;
            color: #666666;
            line-height: 25px;
            letter-spacing: 1px;
          }
          .time {
            position: absolute;
            bottom: 0;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 22px;
            letter-spacing: 1px;
            & > span {
              padding-right: 16px;
              .iconfont {
                font-size: 14px;
                padding-right: 8px;
              }
            }
          }
        }
      }
    }
  }
}

.el-loading-spinner {
  display: flex;
  justify-content: center;
}

.vertical2 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}

.el-tabs__header {
  margin: 0;
}

/deep/ .el-tabs__item {
  height: 44px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  line-height: 28px;
  letter-spacing: 1px;
}

/deep/ .el-tabs__nav-wrap::after {
  content: none;
}
</style>
